import * as React from "react";

const IconHeaderCaretLargeUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="currentColor"><polygon fill="currentColor" points="22.545 5.341 22.943 4.943 26.693 1.195 27.091 .797 26.295 .002 25.896 .401 22.545 3.752 19.193 .398 18.795 0 18 .797 18.398 1.195 22.146 4.945 22.545 5.344" transform="matrix(1 0 0 -1 -17.044 5.797)"/></svg>;
};

export default React.memo(IconHeaderCaretLargeUp);
